/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP DashBoard - e-HC 진행률 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState, urlState } from "../../../recoil/menuState";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
/**
* @brief EHP DashBoard - e-HC 진행률 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
//component
function EhcProgress(props) {
    //trans, ref, navigate
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    //props
    const selTree = props.selTree;
    const [ehpProgress, setEhpProgress] = useState({
        "totalCount": 0,
        "totalProgressCount": 0,
        "totalProgress": 0,
        "acbCount": 0,
        "acbProgressCount": 0,
        "acbProgress": 0,
        "vcbCount": 0,
        "vcbProgressCount": 0,
        "vcbProgress": 0,
        "switchBoardCount": 0,
        "switchBoardProgressCount": 0,
        "switchBoardProgress": 0,
        "moldTrCount": 0,
        "moldTrProgressCount": 0,
        "moldTrProgress": 0,
        "oilTrCount": 0,
        "oilTrProgressCount": 0,
        "oilTrProgress": 0,
        "gisCount": 0,
        "gisProgressCount": 0,
        "gisProgress": 0
    });
    function handleEhpProgress(val) {
        setEhpProgress(Object.assign(Object.assign({}, val), { "totalProgress": (val.totalCount === 0) ? 0 : Math.round(val.totalProgressCount / val.totalCount * 100), "acbProgress": (val.acbCount === 0) ? 0 : Math.round(val.acbProgressCount / val.acbCount * 100), "vcbProgress": (val.vcbCount === 0) ? 0 : Math.round(val.vcbProgressCount / val.vcbCount * 100), "switchBoardProgress": (val.switchBoardCount === 0) ? 0 : Math.round(val.switchBoardProgressCount / val.switchBoardCount * 100), "moldTrProgress": (val.moldTrCount === 0) ? 0 : Math.round(val.moldTrProgressCount / val.moldTrCount * 100), "oilTrProgress": (val.oilTrCount === 0) ? 0 : Math.round(val.oilTrProgressCount / val.oilTrCount * 100), "gisProgress": (val.gisCount === 0) ? 0 : Math.round(val.gisProgressCount / val.gisCount * 100) }));
    }
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/maindashboard/ehcprogress`,
        appQuery: { "zoneId": selTree.zone.zoneId },
        userToken: userInfo.loginInfo.token,
        watch: selTree,
    });
    useEffect(() => {
        setRecoilIsLoadinBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            setRecoilIsLoadinBox(false);
            //clog("IN INFOCARS : EHP PROGRESS : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                handleEhpProgress(retData.body);
                //clog("PIN LC INFO : " + czoneStr);
            }
        }
    }, [retData]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "box__header" },
            React.createElement("p", { className: "box__title" }, "e-HC \uC9C4\uD589\uB960"),
            React.createElement("div", { className: "box__etc" })),
        React.createElement("div", { className: "box__body" },
            React.createElement("div", { className: "top" },
                React.createElement("div", { className: "left" },
                    React.createElement("div", { className: "progress-circle" },
                        React.createElement("div", { className: "percent" },
                            React.createElement("svg", null,
                                React.createElement("circle", { cx: "60", cy: "60", r: "55" }),
                                React.createElement("circle", { cx: "60", cy: "60", r: "55", strokeDasharray: `${2 * Math.PI * 55 * (ehpProgress.totalProgress / 100)} ${2 * Math.PI * 55 * (1 - ehpProgress.totalProgress / 100)}`, strokeDashoffset: `${2 * Math.PI * 55 * 0.25}` })),
                            React.createElement("div", { className: "number" },
                                React.createElement("p", null,
                                    ehpProgress.totalProgress,
                                    React.createElement("br", null),
                                    React.createElement("span", null, "%")))))),
                React.createElement("div", { className: "right" },
                    React.createElement("p", { className: "small-tit icon-dot" }, "e-Health Checker \uC9C4\uD589 \uC124\uBE44"),
                    React.createElement("p", { className: "total-num mt-16" },
                        React.createElement("strong", { className: "largetxt" }, ehpProgress.totalProgressCount),
                        React.createElement("span", null,
                            " /",
                            ehpProgress.totalCount),
                        "ea"))),
            React.createElement("ul", { className: "bottom progress-wrap mt-40" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "VCB"),
                    React.createElement("div", { className: "progress-bar" },
                        React.createElement("div", { className: "progress", style: { "width": `${ehpProgress.vcbProgress}%` } },
                            React.createElement("p", { className: "num-detail", style: { "left": `${(ehpProgress.vcbProgress <= 15) ? 0 : ehpProgress.vcbProgress - 15}%` } }, `${ehpProgress.vcbProgressCount}/${ehpProgress.vcbCount} ea`))),
                    React.createElement("p", { className: "num" },
                        React.createElement("strong", null, ehpProgress.vcbProgress),
                        " %")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "ACB"),
                    React.createElement("div", { className: "progress-bar" },
                        React.createElement("div", { className: "progress", style: { "width": `${ehpProgress.acbProgress}%` } },
                            React.createElement("p", { className: "num-detail", style: { "left": `${(ehpProgress.acbProgress <= 15) ? 0 : ehpProgress.acbProgress - 15}%` } }, `${ehpProgress.acbProgressCount}/${ehpProgress.acbCount} ea`))),
                    React.createElement("p", { className: "num" },
                        React.createElement("strong", null, ehpProgress.acbProgress),
                        " %")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "Mold TR"),
                    React.createElement("div", { className: "progress-bar" },
                        React.createElement("div", { className: "progress", style: { "width": `${ehpProgress.moldTrProgress}%` } },
                            React.createElement("p", { className: "num-detail", style: { "left": `${(ehpProgress.moldTrProgress <= 15) ? 0 : ehpProgress.moldTrProgress - 15}%` } }, `${ehpProgress.moldTrProgressCount}/${ehpProgress.moldTrCount} ea`))),
                    React.createElement("p", { className: "num" },
                        React.createElement("strong", null, ehpProgress.moldTrProgress),
                        " %")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC720\uC785\uC2DD TR"),
                    React.createElement("div", { className: "progress-bar" },
                        React.createElement("div", { className: "progress", style: { "width": `${ehpProgress.oilTrProgress}%` } },
                            React.createElement("p", { className: "num-detail", style: { "left": `${(ehpProgress.oilTrProgress <= 15) ? 0 : ehpProgress.oilTrProgress - 15}%` } }, `${ehpProgress.oilTrProgressCount}/${ehpProgress.oilTrCount} ea`))),
                    React.createElement("p", { className: "num" },
                        React.createElement("strong", null, ehpProgress.oilTrProgress),
                        " %")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "GIS"),
                    React.createElement("div", { className: "progress-bar" },
                        React.createElement("div", { className: "progress", style: { "width": `${ehpProgress.gisProgress}%` } },
                            React.createElement("p", { className: "num-detail", style: { "left": `${(ehpProgress.gisProgress <= 15) ? 0 : ehpProgress.gisProgress - 15}%` } }, `${ehpProgress.gisProgressCount}/${ehpProgress.gisCount} ea`))),
                    React.createElement("p", { className: "num" },
                        React.createElement("strong", null, ehpProgress.gisProgress),
                        " %")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBC30\uC804\uBC18"),
                    React.createElement("div", { className: "progress-bar" },
                        React.createElement("div", { className: "progress", style: { "width": `${ehpProgress.switchBoardProgress}%` } },
                            React.createElement("p", { className: "num-detail", style: { "left": `${(ehpProgress.switchBoardProgress <= 15) ? 0 : ehpProgress.switchBoardProgress - 15}%` } }, `${ehpProgress.switchBoardProgressCount}/${ehpProgress.switchBoardCount} ea`))),
                    React.createElement("p", { className: "num" },
                        React.createElement("strong", null, ehpProgress.switchBoardProgress),
                        " %"))))));
}
export default EhcProgress;
